import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import NewsletterPopup from './components/NewsletterPopup';
import MarketingScripts from './components/MarketingScripts';
import Home from './pages/Home';
import Programs from './pages/Programs';
import Instructors from './pages/Instructors';
import Schedule from './pages/Schedule';
import Contact from './pages/Contact';
import About from './pages/About';
import Pricing from './pages/Pricing';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        const offset = 80;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <MarketingScripts />
      <ScrollToTop />
      <Navigation />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brazilian-jiu-jitsu-training-programs" element={<Programs />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/instructors" element={<Instructors />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/contact-bjj-culver-city" element={<Contact />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-delta-bjj-culver-city" element={<About />} />
        </Routes>
      </main>
      <Footer />
      <NewsletterPopup />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
